'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _components = require('../../components');

var _PlanScorecardFundIssueAccordionItem = require('./PlanScorecardFundIssueAccordionItem.css');

var _PlanScorecardFundIssueAccordionItem2 = _interopRequireDefault(_PlanScorecardFundIssueAccordionItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanScorecardFundIssueAccordionItem = (_dec = (0, _reactCssModules2.default)(_PlanScorecardFundIssueAccordionItem2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PlanScorecardFundIssueAccordionItem, _Component);

  function PlanScorecardFundIssueAccordionItem(props) {
    (0, _classCallCheck3.default)(this, PlanScorecardFundIssueAccordionItem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PlanScorecardFundIssueAccordionItem.__proto__ || (0, _getPrototypeOf2.default)(PlanScorecardFundIssueAccordionItem)).call(this, props));

    _this.state = {
      url: _this.generateFundDescriptionUrl()
    };
    return _this;
  }

  (0, _createClass3.default)(PlanScorecardFundIssueAccordionItem, [{
    key: 'generateFundDescriptionUrl',
    value: function generateFundDescriptionUrl() {
      var domain = '';
      var path = '';
      switch (this.props.el.id) {
        case 'fff':
          domain = 'fossilfreefunds';
          path = 'fossil-fuel-investments';
          break;
        case 'dff':
          domain = 'deforestationfreefunds';
          path = 'profile';
          break;
        case 'gef':
          domain = 'genderequalityfunds';
          path = 'gender-lens-score';
          break;
        case 'gff':
          domain = 'gunfreefunds';
          path = 'gun-investments';
          break;
        case 'pff':
          domain = 'prisonfreefunds';
          path = 'prison-industrial-complex-investments';
          break;
        case 'wff':
          domain = 'weaponfreefunds';
          path = 'weapon-investments';
          break;
        case 'tff':
          domain = 'tobaccofreefunds';
          path = 'tobacco-profile';
          break;
      }
      var sName = _format2.default.sanitize(this.props.fund.fund_legal_name);
      var sTicker = this.props.fund.ticker || 'N';
      var _props$fund = this.props.fund,
          fund_id = _props$fund.fund_id,
          investment_vehicle_id = _props$fund.investment_vehicle_id;

      return 'https://' + domain + '.org/fund/' + sName + '/' + sTicker + '/' + path + '/' + fund_id + '/' + investment_vehicle_id;
    }

    //

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'esg-btn-wrap' },
        _react2.default.createElement(
          _components.Link,
          {
            to: this.state.url,
            title: this.props.el.name + ' - ' + this.props.fund.fund_legal_name
          },
          _react2.default.createElement(
            'div',
            { styleName: 'esg-btn' },
            _react2.default.createElement(
              'div',
              { styleName: 'esg-btn-lbl' },
              _react2.default.createElement(
                'b',
                null,
                this.props.el.name
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'span',
                null,
                this.props.el.description
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'esg-btn-grade grade-' + this.props.fund[this.props.el.grade] },
              _format2.default.score(this.props.fund[this.props.el.grade])
            )
          )
        )
      );
    }
  }]);
  return PlanScorecardFundIssueAccordionItem;
}(_react.Component), _class2.propTypes = {
  fund: _react.PropTypes.object.isRequired,
  el: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = PlanScorecardFundIssueAccordionItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardFundIssueAccordionItem/PlanScorecardFundIssueAccordionItem.js
// module id = 1417
// module chunks = 0